/**
 * The guard-drop recovery (combat design 2026-10-11 guard-read; data/guardRead.ts `GUARD_READ.dropFrames`): in a bout's
 * fight (round 2 on, `DUEL_FLAGS.v2`), a fighter letting a raised guard go is in recovery for a few frames (the bout's own
 * recovery lock, systems/duelRecovery.ts `startStop`, tagged `guardDrop`). PvE and the main game are untouched.
 */
import { DUEL_FLAGS } from '../data/duelMatch';
import { GUARD_READ } from '../data/guardRead';
import type { PlayerCommand } from '../world';
import { duelRecoveryOf } from './duelRecovery';
import type { SystemHost, WorldSystem } from './types';

export class DuelGuardDropSystem implements WorldSystem {
  readonly name = 'duelGuardDrop';

  constructor(private readonly h: SystemHost) {}

  refuse(cmd: PlayerCommand): boolean {
    if (cmd.t !== 'block' || cmd.on || GUARD_READ.dropFrames <= 0) return false;
    const w = this.h.world;
    const p = w.player;
    const b = w.pvpBout;
    if (!p.blocking || !DUEL_FLAGS.v2 || !b?.fight || (b.a !== p.id && b.b !== p.id)) return false;
    duelRecoveryOf(w)?.startStop(p.id, GUARD_READ.dropFrames / 60, 'guardDrop');
    return false;
  }
}
